const insertSpaceIntoEmptyTags = (html: string): string => {
  return html.replace(/(<(h[1-6]|ref)[^>]*>)\s*(<\/\2>)/g, '$1&nbsp;$3');
  // return html.replace(/(<h[1-6][^>]*>)\s*(<\/h[1-6]>)/g, '$1&nbsp;$2');
};

export default insertSpaceIntoEmptyTags;
